import { render, staticRenderFns } from "./DisplayName.vue?vue&type=template&id=103fc7f3&scoped=true"
import script from "./DisplayName.vue?vue&type=script&lang=js"
export * from "./DisplayName.vue?vue&type=script&lang=js"
import style0 from "./DisplayName.vue?vue&type=style&index=0&id=103fc7f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103fc7f3",
  null
  
)

export default component.exports